import axios from 'axios';
import NProgress from 'nprogress';
import { isLockedSmsRequest } from './sms-request.helper';

NProgress.configure({ showSpinner: false });

function getConfig() {
  let promise = null;
  return () => {
    if (!promise) {
      promise = axios.get('/assets/config.json').then((response) => {
        return response.data;
      });
    }
    return promise;
  };
}

export const getConfigMemoized = getConfig();

const httpClient = axios.create({
  baseURL: '',
  timeout: 5000,
});

/* Interceptors */
httpClient.interceptors.request.use(
  async (config) => {
    config.baseURL = (await getConfigMemoized()).VITE_APP_API_BASE_URL;
    return config;
  },
  (error) => Promise.reject(error)
);

httpClient.interceptors.request.use(
  (config) => {
    NProgress.start();

    if (isLockedSmsRequest(config)) {
      return Promise.reject(
        'Извините, на данный момент сервис недоступен, попробуйте позже'
      );
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

httpClient.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (err) => {
    NProgress.done();
    return Promise.reject(err);
  }
);

export default httpClient;
